import _regeneratorRuntime from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _classCallCheck from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "D:\\_Work\\_emd\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import { ParticlesInteractorBase } from "../../../Core/Utils/ParticlesInteractorBase";
import { getDistances } from "../../../Utils/NumberUtils";
export var Attractor =
/*#__PURE__*/
function (_ParticlesInteractorB) {
  _inherits(Attractor, _ParticlesInteractorB);

  function Attractor(container) {
    _classCallCheck(this, Attractor);

    return _possibleConstructorReturn(this, _getPrototypeOf(Attractor).call(this, container));
  }

  _createClass(Attractor, [{
    key: "interact",
    value: function interact(p1) {
      var _a, container, distance, pos1, query, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, p2, pos2, _getDistances, dx, dy, rotate, ax, ay, p1Factor, p2Factor;

      return _regeneratorRuntime.async(function interact$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              container = this.container, distance = (_a = p1.retina.attractDistance) !== null && _a !== void 0 ? _a : container.retina.attractDistance, pos1 = p1.getPosition(), query = container.particles.quadTree.queryCircle(pos1, distance);
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _iteratorError = undefined;
              _context.prev = 4;
              _iterator = query[Symbol.iterator]();

            case 6:
              if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
                _context.next = 18;
                break;
              }

              p2 = _step.value;

              if (!(p1 === p2 || !p2.options.move.attract.enable || p2.destroyed || p2.spawning)) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("continue", 15);

            case 10:
              pos2 = p2.getPosition(), _getDistances = getDistances(pos1, pos2), dx = _getDistances.dx, dy = _getDistances.dy, rotate = p1.options.move.attract.rotate, ax = dx / (rotate.x * 1000), ay = dy / (rotate.y * 1000), p1Factor = p2.size.value / p1.size.value, p2Factor = 1 / p1Factor;
              p1.velocity.x -= ax * p1Factor;
              p1.velocity.y -= ay * p1Factor;
              p2.velocity.x += ax * p2Factor;
              p2.velocity.y += ay * p2Factor;

            case 15:
              _iteratorNormalCompletion = true;
              _context.next = 6;
              break;

            case 18:
              _context.next = 24;
              break;

            case 20:
              _context.prev = 20;
              _context.t0 = _context["catch"](4);
              _didIteratorError = true;
              _iteratorError = _context.t0;

            case 24:
              _context.prev = 24;
              _context.prev = 25;

              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }

            case 27:
              _context.prev = 27;

              if (!_didIteratorError) {
                _context.next = 30;
                break;
              }

              throw _iteratorError;

            case 30:
              return _context.finish(27);

            case 31:
              return _context.finish(24);

            case 32:
            case "end":
              return _context.stop();
          }
        }
      }, null, this, [[4, 20, 24, 32], [25,, 27, 31]]);
    }
  }, {
    key: "isEnabled",
    value: function isEnabled(particle) {
      return particle.options.move.attract.enable;
    }
  }, {
    key: "reset",
    value: function reset() {}
  }]);

  return Attractor;
}(ParticlesInteractorBase);